
(function () {
    'use strict';
    angular.module('core')
        .service('keycloakService', keycloakService);

    keycloakService.$inject = ['keycloakConfig'];
    function keycloakService(keycloakConfig) {
        var service = this;
        service.keycloak = new Keycloak(keycloakConfig);

        return {
            login: login,
            logout: logout,
            getAccessToken: getAccessToken,
            getResourceAccess: getResourceAccess,
            updateAccessToken: updateAccessToken,
            getInitPromise: getInitPromise
        };

        ///////////////////////////

        function login(path) {
            if (!path) {
                path = '/map?logged-in';
            }
            if (path.indexOf('?' === -1)) {
                // keycloak appends parameters with '&' so we need to work-around by adding first parameter with `?`
                path += '?logged-in';
            }
            service.initPromise = service.keycloak.init({
                onLoad: 'login-required',
                redirectUri: window.location.href.split('#')[0] + '#' + path
            });
            return service.initPromise;
        }

        function logout(path) {
            if (!path) {
                path = '/login?info=logout';
            }
            service.keycloak.logout({ redirectUri: window.location.href.split('#')[0] + '#' + path });
        }

        function getAccessToken() {
            return service.keycloak.token;
        }

        function getResourceAccess() {
            return service.keycloak.resourceAccess[keycloakConfig.clientId];
        }

        function updateAccessToken() {
            service.keycloak.updateToken(keycloakConfig.accessTokenMinValidity);
        }

        function getInitPromise() {
            return service.initPromise
        }
    }

})();
